import { render, staticRenderFns } from "./descListaCliente.vue?vue&type=template&id=5bc9d3ee&scoped=true&"
import script from "./descListaCliente.vue?vue&type=script&lang=js&"
export * from "./descListaCliente.vue?vue&type=script&lang=js&"
import style0 from "./descListaCliente.vue?vue&type=style&index=0&id=5bc9d3ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc9d3ee",
  null
  
)

export default component.exports